
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car/pay-per-mile",
      function () {
        return require("private-next-pages/car/pay-per-mile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car/pay-per-mile"])
      });
    }
  